// extracted by mini-css-extract-plugin
export default {"container":"Overlay_container__6xST3","blur":"Overlay_blur__D9JY3","active":"Overlay_active__vcjY3","contained":"Overlay_contained__gzkjc"};